import { render, staticRenderFns } from "./CbsGroupbyItem.vue?vue&type=template&id=5079c8ac&scoped=true"
import script from "./CbsGroupbyItem.vue?vue&type=script&lang=js"
export * from "./CbsGroupbyItem.vue?vue&type=script&lang=js"
import style0 from "./CbsGroupbyItem.vue?vue&type=style&index=0&id=5079c8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5079c8ac",
  null
  
)

export default component.exports